import { getUserGroupContactSecondaryLabels, type UserGroupTypeInput } from 'noddi-util';

export type CustomerInfoCellUserGroup = {
  name: string;
  isPersonal?: boolean;
  type?: UserGroupTypeInput['type'];
  users?: Array<{
    firstName?: string | null;
    lastName?: string | null;
    phoneNumber?: string | null;
    email?: string | null;
  }>;
};

export const customerInfoName = (userGroup: CustomerInfoCellUserGroup): string => {
  const firstUser = userGroup.users?.[0];
  if (userGroup.isPersonal && firstUser) {
    const fullName = `${firstUser.firstName ?? ''} ${firstUser.lastName ?? ''}`.trim();
    return fullName || userGroup.name;
  }
  return userGroup.name;
};

export const customerInfoSearchLabel = (userGroup: CustomerInfoCellUserGroup): string =>
  [
    customerInfoName(userGroup),
    ...getUserGroupContactSecondaryLabels({
      isPersonal: userGroup.isPersonal ?? false,
      users: userGroup.users ?? []
    })
  ].join(' ');
